import React from 'react';
import Navigation from './Navigation';

// eslint-disable-next-line react/display-name
export default function () {
  return (
    <aside className="ms-depth-4 drawer drawer--desktop">
      <Navigation />
    </aside>
  );
}
